module.exports = __webpack_public_path__ + "img/technology_icon_04.6d9d72fc.png";